import { mediaData } from '@/mocks/homeData';

const mediaImages = [
  'https://readdy.ai/api/search-image?query=Dynamic%20anime%20style%20video%20thumbnail%20with%20dramatic%20action%20scene%20in%20warm%20orange%20and%20red%20tones%2C%20cinematic%20composition%20with%20characters%20in%20motion%2C%20modern%20digital%20art%20style%2C%20soft%20gradient%20background%2C%20professional%20production%20quality&width=720&height=405&seq=media-thumb-1&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Colorful%20manga%20reading%20app%20tutorial%20thumbnail%20with%20smartphone%20displaying%20comic%20pages%20in%20warm%20amber%20lighting%2C%20clean%20modern%20design%2C%20friendly%20illustration%20style%2C%20soft%20background%2C%20editorial%20quality&width=720&height=405&seq=media-thumb-2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20manga%20comic%20books%20arranged%20artistically%20on%20wooden%20surface%20in%20warm%20golden%20light%2C%20lifestyle%20photography%2C%20editorial%20recommendation%20concept%2C%20soft%20shadows%2C%20premium%20aesthetic&width=720&height=405&seq=media-thumb-3&orientation=landscape',
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-4 whitespace-nowrap">
            精彩视频
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            漫画相关视频精选
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">精彩漫画改编PV、平台使用指南和编辑推荐视频合集</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaData.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer group">
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={mediaImages[i]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-600 transition-colors">
                    <i className="ri-play-fill text-white text-xl md:text-2xl ml-0.5"></i>
                  </span>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-1 text-[10px] text-white bg-black/60 rounded whitespace-nowrap">
                  {item.views} 次播放
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5 line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 mb-2 line-clamp-2">{item.desc}</p>
                <span className="text-[10px] text-foreground-400 whitespace-nowrap">{item.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}